// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePollVoteBody = {
  messageId: string;
  optionIds: string[];
};

export type typePollVoteOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    messageId: string;
    myVoteOptionIds: string[];
    totalVotes: number;
  };
};

export type typePollVoteOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePollVoteOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePollVoteOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPollVoteBody = {
  type: "object",
  properties: {
    messageId: { type: "string", maxLength: 3000, minLength: 1 },
    optionIds: {
      type: "array",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
  },
  required: ["messageId", "optionIds"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPollVote(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPollVoteBody);
  }

  return async function postPollVote(
    payload: typePollVoteBody,
  ): Promise<typePollVoteOutput200 | typePollVoteOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPollVote" failed before calling the network. #2ee768b0bf2d`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#2ee768b0bf2d" },
        },
        data: null,
      } as typePollVoteOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/poll/vote`,
      httpMethod: "POST",
      options,
    })) as typePollVoteOutput200 | typePollVoteOutput400;
  };
}
